import { handleError, MyAxios } from '@app/services/SettingAxios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ModalProductType } from '../types/catalogSchema';
import { PartBrand, ProductSpecifications, SeasonEnum } from '@entities/Product';

export const fetchGetArchivedModels = createAsyncThunk<
  { data: ModalProductType[] },
  { brand: string; part: PartBrand; regionId: number; season?: SeasonEnum }
>('catalog/fetchGetArchivedModels', async ({ brand, part, regionId, season }) => {
  const strSeason = season === SeasonEnum.Winter || season === SeasonEnum.Summer ? `&${ProductSpecifications.TyresSeason}=${season}` : '';

  const urlFetch = [`/api/catalog/archived-models/filter?part=${part}&tyres_developer[]=${brand}&regionId=${regionId}`, strSeason];

  return await MyAxios.get(urlFetch.join(''))
    .then(response => response.data)
    .catch(handleError);
});
